<div class="margins" fxLayout="column">
  <div class="header">
    <div fxLayout="row">
      <img *ngIf="imageSrc" [src]="imageSrc" class="mini-screenshot" height="80" width="80" />
      <div fxLayout="column" fxLayoutAlign="center left">
        <div class="title-text">{{ 'SUMMARY.TITLE' | translate }}</div>
        <div class="sub-text">{{ 'SUMMARY.DESCRIPTION' | translate }}</div>
      </div>
      <div fxFlex></div>
      <app-isomaster-red-loading *ngIf="loading" class="share-button"></app-isomaster-red-loading>
      <app-isomasters-button (modularClick)="createPDF()" *ngIf="!readOnly" [loading]="loadingPDF" class="share-button">
        <div class="share-button-text" description fxLayout="row" fxLayoutAlign="center center">
          <span
            [inlineSVG]="'assets/svg/icon-download.svg'"
            [setSVGAttributes]="{ width: '16px', height: '16px' }"
            class="icon"></span>
          <span class="share-link">{{ 'SUMMARY.CREATEPDF' | translate }}</span>
        </div>
      </app-isomasters-button>
      <app-isomasters-button
        (modularClick)="create2dPlan()"
        *ngIf="!readOnly && configurationIdExists && hasToken"
        [disabled]="loading"
        [loading]="loading2d"
        class="share-button">
        <div class="share-button-text" description fxLayout="row" fxLayoutAlign="center center">
          <span
            [inlineSVG]="'assets/svg/icon-download.svg'"
            [setSVGAttributes]="{ width: '16px', height: '16px' }"
            class="icon"></span>
          <span class="share-link">{{ 'SUMMARY.CREATE2DPLAN' | translate }}</span>
        </div>
      </app-isomasters-button>
      <app-isomasters-button
        (modularClick)="shareLink()"
        *ngIf="!readOnly && configurationIdExists && hasToken"
        [disabled]="loading"
        class="share-button">
        <div class="share-button-text" description fxLayout="row" fxLayoutAlign="center center">
          <span
            [inlineSVG]="'assets/svg/icon-share.svg'"
            [setSVGAttributes]="{ width: '16px', height: '16px' }"
            class="icon"></span>
          <span class="share-link">{{ 'SUMMARY.SHARELINK' | translate }}</span>
        </div>
      </app-isomasters-button>
    </div>
  </div>
  <div class="line"></div>

  <div class="content" fxFlex="100%">
    <app-summary-collisions
      *ngIf="!!conflicts && (conflicts.collisions.length > 0 || conflicts.invalidPanels.length > 0)">
      <div *ngFor="let invalidPanel of conflicts.invalidPanels" class="collisions">
        <div class="title">
          {{ 'INVALID_PANEL.TITLE' | translate | replace: '[SIZE]' : invalidPanel.size }}
        </div>
      </div>
      <div *ngFor="let collision of conflicts.collisions" class="collisions">
        <div class="title">{{ getTitleForCollision(collision) }}</div>
        <div>{{ getATextForCollision(collision) }}</div>
        <div>{{ getBTextForCollision(collision) }}</div>
      </div>
    </app-summary-collisions>

    <app-summary-step [readOnly]="readOnly" [stepNumber]="1">
      <div fxLayout="row">
        <div class="property-title">{{ 'STEP1.PURPOSE' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">{{ purpose }}</div>
      </div>
    </app-summary-step>
    <app-summary-step [readOnly]="readOnly" [stepNumber]="2">
      <div fxLayout="row">
        <div class="property-title">{{ 'STEP2.WALLTHICKNESS' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">{{ wallThickness }}</div>
      </div>
    </app-summary-step>
    <app-summary-step [readOnly]="readOnly" [stepNumber]="3">
      <div fxLayout="row">
        <div class="property-title">{{ 'STEP3.SIZEINTERNAL' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">
          {{ length | number: '1.0-0' : currentLocale }} mm x {{ width | number: '1.0-0' : currentLocale }} mm x
          {{ height | number: '1.0-0' : currentLocale }} mm
        </div>
      </div>
      <div fxLayout="row">
        <div class="property-title">{{ 'STEP3.SIZEEXTERNAL' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">
          {{ lengthExternal | number: '1.0-0' : currentLocale }} mm x
          {{ widthExternal | number: '1.0-0' : currentLocale }} mm x
          {{ heightExternal | number: '1.0-0' : currentLocale }}
          mm
        </div>
      </div>
    </app-summary-step>
    <app-summary-step [readOnly]="readOnly" [stepNumber]="4">
      <div fxLayout="row">
        <div class="property-title">{{ 'SUMMARY.FLOORINCELL' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">{{ floorInCell }}</div>
      </div>
      <div *ngIf="floorInCoolingCell" fxLayout="row">
        <div class="property-title">{{ 'SUMMARY.FLOORTYPE' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">{{ floorType }}</div>
      </div>
      <div *ngIf="floorInCoolingCell" fxLayout="row">
        <div class="property-title">{{ 'STEP4.SUNKENFLOOR' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">{{ sunkenFloor }}</div>
      </div>
      <div *ngIf="floorInCoolingCell" fxLayout="row">
        <div class="property-title">{{ 'STEP4.PLINTHSINSIDE' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">{{ plinthsInside }}</div>
      </div>
      <!-- <div fxLayout="row" *ngIf="floorInCoolingCell">
              <div class="property-title">{{'STEP4.PLINTHSOUTSIDE'|translate}}</div>
              <div fxFlex></div>
              <div class="property-value">{{plinthsOutside}}</div>
            </div> -->
      <div *ngIf="floorInCoolingCell" fxLayout="row">
        <div class="property-title">{{ 'STEP4.PROFILES' | translate }}</div>
        <div fxFlex></div>
        <div class="property-value">{{ ventilationProfiles }}</div>
      </div>
      <!-- <div fxLayout="row" *ngIf="floorInCoolingCell">
              <div class="property-title">{{'STEP4.CEILINGMOLDINGS'|translate}}</div>
              <div fxFlex></div>
              <div class="property-value">{{ceilingMoldings}}</div>
            </div> -->
    </app-summary-step>
    <app-summary-step [readOnly]="readOnly" [stepNumber]="5">
      <div *ngIf="!!innerWalls && innerWalls.length > 0; else noInnerWalls">
        <div *ngFor="let innerWall of innerWalls">
          <div fxLayout=" row">
            <div class="property-title">
              {{ 'WALL.4' | translate }} {{ getId(innerWall.id) }}: {{ 'WALL.' + innerWall.placedOnSide | translate }}
            </div>
            <div fxFlex></div>
            <div class="property-value">
              {{ 'INNERWALL.' + innerWallTypes[innerWall.type] | uppercase | translate }}
              <br />
              {{ getLeft(innerWall) | number: '1.0-0' : currentLocale }} mm {{ 'SUMMARY.FROMLEFTCORNER' | translate }}
              <span *ngIf="innerWall.rotated; else notMirrored">
                <br />
                {{ 'STEPINNERWALL.MIRRORED' | translate }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </app-summary-step>
    <app-summary-step [readOnly]="readOnly" [stepNumber]="6">
      <div *ngFor="let door of doors()">
        <div class="property-title">
          {{ 'WALL.' + door.side | translate }}
          <span *ngIf="door.side === wallSide.inner">{{ getId(door.innerWallId) }}</span>
          ({{ getWidthOfWall(door) | number: '1.0-0' : currentLocale }} mm)
        </div>
        <div fxFlex></div>
        <div class="property-value">
          {{ doorTypeToString(door.doorModel.type) }}, {{ 'STEP5.' + directionToString(door.direction) | translate }}
          <br />
          {{ 'SUMMARY.CLEAROPENING' | translate }}:
          {{ door.doorModel.openingWidth | number: '1.0-0' : currentLocale }} mm x
          {{ door.doorModel.openingHeight | number: '1.0-0' : currentLocale }}
          mm
          <br />
          {{ door.left | number: '1.0-0' : currentLocale }} mm {{ 'SUMMARY.FROMLEFTCORNER' | translate }}
          <ng-container *ngIf="door.doorModel.type === doorType.Turn">
            <br />
            {{ 'DOORHINGE.HINGE' | translate }}: {{ 'DOORHINGE.' + door.hingeType | uppercase | translate }},
            {{ 'DOORHANDLE.HANDLE' | translate }}: {{ 'DOORHANDLE.' + door.doorHandleType | uppercase | translate }}
          </ng-container>
          <br />
          {{ 'STEP6.FINISH' | translate }} {{ 'STEP6.OUTSIDESMALL' | translate }}:
          {{ 'FINISHTYPES1.' + door.leafExteriorFinish | uppercase | translate }},
          {{ 'FINISHTYPES2.' + door.leafExteriorFinish | uppercase | translate }}
          <br />
          {{ 'STEP6.FINISH' | translate }} {{ 'STEP6.INSIDESMALL' | translate }}:
          {{ 'FINISHTYPES1.' + door.leafInteriorFinish | uppercase | translate }},
          {{ 'FINISHTYPES2.' + door.leafInteriorFinish | uppercase | translate }}
        </div>
      </div>
    </app-summary-step>

    <app-summary-step [readOnly]="readOnly" [stepNumber]="7">
      <div *ngFor="let wallFinish of wallFinishes()">
        <div>
          <div class="property-title">
            <span>{{ 'WALL.' + wallFinish.side | translate }}</span>
            {{ 'WALL.EXTERIOR' | translate }}
          </div>
          <div fxFlex></div>
          <div class="property-value">
            {{ 'FINISHTYPES1.' + wallFinish.exterior | translate }},
            {{ 'FINISHTYPES2.' + wallFinish.exterior | translate }}
          </div>
        </div>
        <div>
          <div class="property-title">
            <span>{{ 'WALL.' + wallFinish.side | translate }}</span>
            {{ 'WALL.INTERIOR' | translate }}
          </div>
          <div fxFlex></div>
          <div class="property-value">
            {{ 'FINISHTYPES1.' + wallFinish.interior | translate }},
            {{ 'FINISHTYPES2.' + wallFinish.interior | translate }}
          </div>
        </div>
      </div>
      <div *ngFor="let innerWall of innerWalls">
        <div>
          <div class="property-title">
            <span>{{ 'WALL.' + wallSide.inner | translate }} {{ getId(innerWall.id) }}</span>
            {{ 'WALL.EXTERIOR' | translate }}
          </div>
          <div fxFlex></div>
          <div class="property-value">
            {{ 'FINISHTYPES1.' + innerWall.exteriorFinish | translate }},
            {{ 'FINISHTYPES2.' + innerWall.exteriorFinish | translate }}
          </div>
        </div>
        <div>
          <div class="property-title">
            <span>{{ 'WALL.' + wallSide.inner | translate }} {{ getId(innerWall.id) }}</span>
            {{ 'WALL.INTERIOR' | translate }}
          </div>
          <div fxFlex></div>
          <div class="property-value">
            {{ 'FINISHTYPES1.' + innerWall.interiorFinish | translate }},
            {{ 'FINISHTYPES2.' + innerWall.interiorFinish | translate }}
          </div>
        </div>
      </div>
    </app-summary-step>
  </div>
</div>

<ng-template #noInnerWalls>
  <div class="property-title">{{ 'STEPINNERWALL.NOINNERWALLS' | translate }}</div>
</ng-template>
<ng-template #notMirrored>
  <br />
  {{ 'STEPINNERWALL.NOTMIRRORED' | translate }}
</ng-template>
